import styled from 'styled-components';
import HeartIcon from 'mdi-react/HeartOutlineIcon';
import { layout } from '@prisjakt/ui-base';

export const View = styled.div`
  padding: ${layout.spacing.xSmall};
`;

export const CreateListIcon = styled(HeartIcon).attrs(p => ({
  color: p.theme.icons.quaternary,
}))``;
